const CHAVE = 'digitacao:salvamento';

const gerarId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

const obterStore = () => {
    try {
        return window.localStorage;
    } catch (e) {
        return null;
    }
};

const gravar = itens => {
    const store = obterStore();

    if (!store) return;

    try {
        store.setItem(CHAVE, JSON.stringify(itens));
    } catch (e) {
        return;
    }
};

const DigitacaoSalvamentoStorage = {
    listar: () => {
        const store = obterStore();

        if (!store) return [];

        try {
            const bruto = store.getItem(CHAVE);
            const itens = bruto ? JSON.parse(bruto) : [];

            return Array.isArray(itens) ? itens : [];
        } catch (e) {
            return [];
        }
    },

    quantidade: () => DigitacaoSalvamentoStorage.listar().length,

    adicionar: payload => {
        const itens = DigitacaoSalvamentoStorage.listar();

        itens.push({ id: gerarId(), payload, tentativas: 0, criadoEm: Date.now() });
        gravar(itens);
    },

    remover: id => gravar(DigitacaoSalvamentoStorage.listar().filter(item => item.id !== id)),

    incrementarTentativas: id =>
        gravar(
            DigitacaoSalvamentoStorage.listar().map(item =>
                item.id === id ? { ...item, tentativas: item.tentativas + 1 } : item
            )
        ),

    limpar: () => gravar([]),
};

export default DigitacaoSalvamentoStorage;
